/**
 * METİN DOSYASI İNDİRME.
 *
 * `GET /rehber/disa-aktar/:tur` bir DOSYA döndürmüyor; JSON gövdesi içinde
 * Markdown metni veriyor (`RehberDisaAktarimDto.icerik`). Bağlantı olarak
 * açılamaz — jetonlu bir uç, `<a href>` `Authorization` başlığı taşımaz ve
 * 401 alırdı.
 *
 * Bu yüzden metin istemcide `Blob`a sarılıp indiriliyor. Yeni bağımlılık yok.
 *
 * NESNE ADRESİ SERBEST BIRAKILIR. `revokeObjectURL` çağrılmazsa 77 maddelik
 * belge sekme kapanana dek bellekte kalır; kullanıcı iki belgeyi birkaç kez
 * indirdiğinde birikir.
 */
export function metinDosyasiIndir(
  dosyaAdi: string,
  icerik: string,
  mimeTuru = 'text/markdown',
): void {
  const nesne = new Blob([icerik], { type: `${mimeTuru};charset=utf-8` });
  const adres = URL.createObjectURL(nesne);

  const bag = document.createElement('a');
  bag.href = adres;
  bag.download = dosyaAdi;

  // Firefox, belgeye eklenmemiş bir bağlantının tıklamasını yok sayar.
  document.body.appendChild(bag);
  bag.click();
  document.body.removeChild(bag);

  URL.revokeObjectURL(adres);
}

/**
 * Dosya adı için güvenli parça.
 *
 * Belge başlığı doğrudan dosya adı yapılsaydı (`Belediye Mesai Sistemi —
 * Kullanım Kılavuzu`) tire ve boşluklar bazı sistemlerde sorun çıkarırdı.
 */
export function dosyaAdiParcasi(metin: string): string {
  return metin
    .toLocaleLowerCase('tr-TR')
    .replace(/[çğıöşü]/g, (h) => ({ ç: 'c', ğ: 'g', ı: 'i', ö: 'o', ş: 's', ü: 'u' })[h] ?? h)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
